import styled from 'styled-components';

import DatePicker from './DatePicker';

const StyledDatePicker = styled(DatePicker)`
    z-index: 200;
    border-width: 0;
    background-color: ${(props) =>
        props.backgroundColor ?? props.theme.colours.white};
    display: inline-block;
    color: ${(props) => props.theme.colours.grey};
    line-height: 1.2;
    border-radius: ${(props) => props.theme.corners.full}px;
    cursor: pointer;
    display: block;
    height: 5.6rem;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 100%;

    &.active {
        border: 0.1rem solid ${(props) => props.theme.colours.grey};
    }
`;
export default StyledDatePicker;
